import React, {Fragment, memo} from "react";
import {isEmpty} from "lodash";
import PropTypes from "prop-types";
import {Col, Label, Row} from "reactstrap";
import DateCreator from "./components/DateCreator";
import InputCreator from "./components/InputCreator";
import SelectCreator from "./components/SelectCreator";
import ToggleCreator from "./components/ToggleCreator";

const CustomFieldsList = (props) => {
  const {fields = [], onChange} = props;

  const fieldCreator = (input) => {
    let {description, id, label, name, options, is_required, type, value} = input;

    const getDateValue = (input) => {
      if (!input) return null;
      if (input instanceof Date) return input;
      if (type === "datetime") {
        return new Date(input);
      } else if (type === "date") {
        // construct date from date only string ex: 2026-01-23
        const [y, m, d] = input.split("-").map(Number);
        return new Date(y, m - 1, d);
      }
    };
    const changeHandler = (e) => {
      const {checked, value} = e.target;
      const newFields = fields.map((field) => {
        if (field.id === id) {
          let newValue = value;
          if (type === "boolean") {
            newValue = checked;
          }
          if (value === "" || (Array.isArray(value) && isEmpty(value))) {
            newValue = null;
          }
          return {
            ...field,
            value: newValue,
          };
        }
        return field;
      });
      onChange(newFields);
    };

    let field;
    switch (type) {
      case "boolean":
        field = (
          <ToggleCreator
            checked={value}
            help_text={description}
            id={name}
            key={id}
            label={label}
            large
            name={name}
            onChange={changeHandler}
            testId={id}
          />
        );
        break;

      case "date":
      case "datetime":
        field = (
          <DateCreator
            data-cy={name}
            dateFormat={type === "datetime" ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd"}
            showTimeSelect={type === "datetime"}
            timeFormat="HH:mm"
            help_text={description}
            id={name}
            key={id}
            isRequired={is_required}
            label={label}
            large
            name={name}
            onChange={(value) => changeHandler({target: {value}})}
            value={getDateValue(value)}
          />
        );
        break;

      case "select":
      case "object":
      case "multiselect":
      case "multiobject":
        field = (
          <SelectCreator
            classNamePrefix={name}
            data-cy={name}
            help_text={description}
            id={name}
            key={id}
            isClearable
            isMulti={type === "multiselect" || type === "multiobject"}
            isRequired={is_required}
            isSearchable
            label={label}
            large
            name={name}
            onChange={changeHandler}
            options={options}
            value={value}
          />
        );
        break;

      case "longtext":
      case "number":
      case "text":
        field = (
          <InputCreator
            data-cy={name}
            help_text={description}
            id={name}
            key={id}
            isRequired={is_required}
            label={label}
            label_for={name}
            large
            name={name}
            onChange={changeHandler}
            type={type === "longtext" ? "textarea" : type}
            value={value}
          />
        );
        break;

      default:
        field = (
          <InputCreator
            data-cy={name}
            help_text={description}
            id={name}
            key={id}
            isRequired={is_required}
            label={label}
            label_for={name}
            large
            name={name}
            onChange={changeHandler}
            type={"text"}
            value={value}
          />
        );
        break;
    }
    return field;
  };
  return (
    <Fragment>
      {!isEmpty(fields) && (
        <Row>
          <Col xs={12}>
            <Label className="roboto-bold mt-1 mb-2" data-cy="custom-fields-label">
              Custom Fields
            </Label>
          </Col>
          {fields.map((input) => {
            return fieldCreator(input);
          })}
        </Row>
      )}
    </Fragment>
  );
};

CustomFieldsList.propTypes = {
  fields: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default memo(CustomFieldsList);
